function timeAgo(time) {
    const date = new Date(time);
    const seconds = Math.floor((new Date() - date) / 1000);

    let interval = Math.floor(seconds / 31536000);
    if (interval > 1) {
        return interval + ' років тому';
    }

    interval = Math.floor(seconds / 2592000);
    if (interval > 1) {
        return interval + ' місяців тому';
    }

    interval = Math.floor(seconds / 86400);
    if (interval > 1) {
        return interval + ' днів тому';
    }

    interval = Math.floor(seconds / 3600);
    if (interval > 1) {
        return interval + ' годин тому';
    }

    interval = Math.floor(seconds / 60);
    if (interval > 1) {
        return interval + ' хвилин тому';
    }

    if(seconds < 10) return 'щойно';

    return Math.floor(seconds) + ' секунд тому';
}
export {timeAgo}
